import styled, { css } from 'styled-components'
import { margin, MarginProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

type VariantProps = {
  secondary?: boolean
  tertiary?: boolean
}

const shouldForwardProp = (prop: string) => {
  return !['secondary', 'tertiary'].includes(String(prop))
}

type DividerProps = MarginProps & VariantProps

type CardProps = VariantProps

type PriceProps = MarginProps & VariantProps

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 320px;
`

const cardSecondaryCss = ({ secondary }: CardProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.background.screenAlt')};
  `

const cardTertiaryCss = ({ tertiary }: CardProps) =>
  tertiary &&
  css`
    background-color: ${themeGet('colors.outerSpaceCrayola')};
    color: ${themeGet('colors.text.inverse')};
  `

export const Card = styled.div.withConfig({ shouldForwardProp })<CardProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 104px;
  max-width: 240px;
  min-width: 220px;
  gap: ${themeGet('space.6')}px;
  background-color: ${themeGet('colors.background.screenContrast')};
  border-radius: 20px;
  padding: ${themeGet('space.5')}px ${themeGet('space.6')}px
    ${themeGet('space.9')}px;

  button {
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
  }

  ${cardSecondaryCss}
  ${cardTertiaryCss}
`

const dividerSecondaryCss = ({ secondary }: DividerProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.line.tertiary')};
  `

export const Divider = styled.div.withConfig({
  shouldForwardProp,
})<DividerProps>`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background-color: ${themeGet('colors.line.quaternary')};

  ${margin}

  ${dividerSecondaryCss}
`

const priceSecondaryCss = ({ secondary }: VariantProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.secondary.main')};
  `

const priceTertiaryCss = ({ tertiary }: VariantProps) =>
  tertiary &&
  css`
    background-color: ${themeGet('colors.background.screenContrast')};
  `

export const Price = styled.div.withConfig({
  shouldForwardProp,
})<PriceProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 78px;
  width: 100%;
  max-width: 204px;
  background-color: ${themeGet('colors.primary.main')};
  gap: ${themeGet('space.1')}px;

  ${priceSecondaryCss}
  ${priceTertiaryCss}

  ${margin}
`
